import { API_STATES } from "@/helpers";

const state = {
  adminStoresGetState : API_STATES.NOT_REQUESTED,
  adminStoresGetError : null,
  adminStores         : [],
  storesCount         : 0
};

export default state;